module.exports = __webpack_public_path__ + "static/phigora-macbook@2x-768x681-d13385c8f7e19c63a59bed2b53f9ecf2.png";